import ApiRoutes from "../../../constants/api-routes";
import { hneAdsApi } from "../../../service";

export const getTopOffers = async (pageSize) =>
  hneAdsApi.get(`${ApiRoutes.GET_TOP_OFFERS}?limit=${pageSize}`);
